import React from 'react'

import AddDocumentsLayout from 'presentation/patient/layouts/CreateSurgicalOrder/AddDocuments'

export default function AddDocuments() {
  return <AddDocumentsLayout />
}
